import useApiQueryData from "../use_api_query_data";
import { API_STATESNAPSHOTS } from "../../api";
import XNGApiQueryParamObject from "../../../types/xng_api_query_param_object";
import { useXNGSelector } from "../../../context/store";
import { selectClientID } from "../../../context/slices/loggedInClientSlice";

type Data = Awaited<
  ReturnType<typeof API_STATESNAPSHOTS.v1StateSnapshotsByDateServiceProviderTypesGet>
>;
type QueryParams = {
  state: string;
  date?: Date;
};

const useApiQueryGetServiceProviderTypesByDate = (
  paramObject: XNGApiQueryParamObject<QueryParams, Data>,
) => {
  const { state, date } = paramObject.queryParams;
  const clientID = useXNGSelector(selectClientID);

  return useApiQueryData({
    // Sorted here rather than at each picker: every consumer feeds this straight into a dropdown as
    // options, and the API returns them in no particular order.
    queryFn: async () => {
      const response = await API_STATESNAPSHOTS.v1StateSnapshotsByDateServiceProviderTypesGet(
        state,
        clientID,
        date,
      );
      return {
        ...response,
        serviceProviderTypes: [...(response.serviceProviderTypes ?? [])].sort((a, b) =>
          (a.name ?? "").localeCompare(b.name ?? ""),
        ),
      };
    },
    queryKey: ["v1StateSnapshotsByDateServiceProviderTypesGet", state, date],
    staleTime: 1000 * 60 * 60 * 5, // 5 hours
    ...(paramObject.options ?? {}),
  });
};

export default useApiQueryGetServiceProviderTypesByDate;
